import React, { PureComponent } from 'react';
import actions from '../../../../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ProductLineItemPage from '../../../presenters/renewals/ProductLineItemPage/ProductLineItemPage';
import PropTypes from 'prop-types';
import { isFieldMutable } from '../../../presenters/renewals/ProductLineItemPage/line-item-page-util';
import { withRouter } from 'react-router';
import * as api from '../../../../services/api';
import LoadingWidget from '../../../widgets/LoadingWidget/LoadingWidget';
import { PRODUCT_LIST_URL } from '../../../../route-names';
import {
  isRenewalMutable,
  itemNeedsApproval,
  getValidationFields
} from '../../../../utils/renewals-util';
import { APPROVAL_LEVELS } from '../../../../utils/util-constants';

class ProductLineItemPageWrapper extends PureComponent {
  constructor(props) {
    super(props);

    this.lineItemId = props.match.params.lineItemId;
    this.branchRouteCustomerId = props.match.params.branchRouteCustomerId;

    this.state = {
      loading: true,
      lineItem: null,
      renewal: null,
      customer: null
    };

    this.loadInitialState = this.loadInitialState.bind(this);
    this.handleChangeLineItem = this.handleChangeLineItem.bind(this);
    this.handleBackButton = this.handleBackButton.bind(this);
  }

  componentDidMount() {
    this.loadInitialState();
  }

  loadInitialState() {
    const lineItemPromise = api.lineItems.get(this.lineItemId);
    const renewalPromise = lineItemPromise
      .then((lineItemResponse) =>
        api.renewals.get(lineItemResponse.data.renewalId)
      )
      .catch((error) => {
        throw Error('unable to get renewals');
      });
    const customerPromise = api.customers.getByBrcId(
      this.branchRouteCustomerId
    );

    Promise.all([lineItemPromise, renewalPromise, customerPromise])
      .then(([lineItemResponse, renewalResponse, customerPromise]) => {
        const renewal = renewalResponse.data;
        const lineItem = lineItemResponse.data;

        renewal.validationErrors.forEach((validationError) => {
          const id = validationError.lineItemId;
          const field = validationError.validationField;

          if (!lineItem.validationFields) {
            lineItem.validationFields = [];
          }

          if (lineItem.lineItemId === id) {
            lineItem.validationFields.push(field.toUpperCase());
            lineItem.requiresApproval = true;
          }
        });

        lineItem.isApprovalRequired = renewal.validationErrors.some(
          (validationError) =>
            validationError.lineItemId === lineItem.lineItemId &&
            (validationError.validityLevel === APPROVAL_LEVELS.TIER3_APPROVAL || validationError.validityLevel === APPROVAL_LEVELS.TIER2_APPROVAL ||
              validationError.validityLevel === APPROVAL_LEVELS.TIER1_APPROVAL)
        );

        this.setState({
          loading: false,
          lineItem,
          renewal,
          customer: customerPromise.data
        });
      })
      .catch((error) => {
        throw Error('unable to download renewal');
      });
  }

  handleChangeLineItem(updatedLineItem, submitUpdates = true) {
    api.renewals
      .validateLineItem(updatedLineItem)
      .then((response) => {
        const isApprovalRequired = itemNeedsApproval(response.data);
        const validationFields = getValidationFields(response.data);
        if (submitUpdates) {
          api.lineItems
            .update(updatedLineItem)
            .then((response) =>
              this.setState({
                lineItem: {
                  ...response.data,
                  isApprovalRequired,
                  validationFields
                },
                apiResponse: 'Line item updated.'
              })
            )
            .catch((error) => {
              console.error(error);
              this.setState({
                apiResponse: 'Error updating line item.'
              });
            });
        } else {
          this.setState({
            lineItem: {
              ...updatedLineItem,
              isApprovalRequired,
              validationFields
            }
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          apiResponse: 'Error validating line item.'
        });
      });
  }

  handleBackButton() {
    this.props.history.push(
      PRODUCT_LIST_URL.replace(
        ':branchRouteCustomerId',
        this.branchRouteCustomerId
      )
    );
  }

  render() {
    return this.state.loading ? (
      <LoadingWidget />
    ) : (
      <ProductLineItemPage
        disabled={
          !isRenewalMutable(this.state.renewal, this.state.customer.branchCode)
        }
        isFieldEditable={isFieldMutable}
        customer={this.state.customer}
        lineItem={this.state.lineItem}
        handleChangeLineItem={this.handleChangeLineItem}
        handleBackButton={this.handleBackButton}
        deliveryFrequencies={this.props.appStore.deliveryFrequencies}
        priceReasonCodes={this.props.appStore.priceReasonCodes}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

ProductLineItemPageWrapper.propTypes = {
  productLineItem: PropTypes.object
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductLineItemPageWrapper)
);
